import React from 'react';
import { useHistory } from 'react-router-dom';

import { useAuthSync } from '../hooks/useAuthSync';
import OnboardingViewBase from '../OnboardingViewBase';
import { CompletedRegistrationView } from './CompletedRegistrationView';

const CompletedRegistration: React.FC = () => {
  const history = useHistory();
  const { account, isLoading } = useAuthSync();

  const handleNavigation = () => {
    history.push('/');
  };

  return (
    <OnboardingViewBase>
      <CompletedRegistrationView
        firstName={account?.firstName}
        isLoading={isLoading}
        onNavigate={handleNavigation}
      />
    </OnboardingViewBase>
  );
};

export default CompletedRegistration;
